import { useEffect, useRef } from 'react'
import { doc, serverTimestamp } from 'firebase/firestore'
import { setDoc } from '../lib/firestore'
import { db } from '../lib/firebase'
import { useAuth } from './useAuth'
import { takePendingIntent } from '../lib/pendingIntent'
import { totemFollowId } from './useTotemFollows'
import { track } from '../lib/analytics'
import { log } from '../lib/logger'

// Re-applies a totem follow a guest made before signing in, for the case where
// linking couldn't preserve their UID (see `lib/auth.ts`). Mounted once at the
// root rather than on the totem route, because sign-in can land the user
// anywhere — the guest-guard's `afterSignIn` rarely points back here.
export function usePendingTotemFollow() {
  const { signedInUid } = useAuth()
  const applyingFor = useRef<string | null>(null)

  useEffect(() => {
    if (!signedInUid || applyingFor.current === signedInUid) return
    applyingFor.current = signedInUid

    const pending = takePendingIntent('totemFollow')
    if (!pending) return
    const [groupId, totemId] = pending.split('_')
    if (!groupId || !totemId) return

    setDoc(doc(db, 'totemFollows', totemFollowId(signedInUid, groupId, totemId)), {
      userId: signedInUid,
      groupId,
      totemId,
      createdAt: serverTimestamp(),
    })
      .then(() => track('totem_followed', { group_id: groupId, entry_point: 'qr' }))
      .catch(err => log('totem', 'pending follow re-apply failed', { error: String(err) }))
  }, [signedInUid])
}
